export enum RequestTypeEnum {
  Kindergarten = 1,
  Preschool = 2,
}
